/**
 * Patients Feature Routes
 */
import type { RouteRecordRaw } from 'vue-router';
import i18next from 'i18next';

export const patientsRoutes: RouteRecordRaw[] = [
  {
    path: '/patients',
    name: 'patients',
    component: () => import('./views/PatientsListView.vue'),
    meta: {
      title: () => i18next.t('nav.patients'),
      requiredEntitlement: 'PATIENT_MANAGEMENT',
    },
  },
  {
    path: '/patients/:id',
    name: 'patient-profile',
    component: () => import('./views/PatientProfile.vue'),
    meta: {
      title: () => i18next.t('patient.profile'),
      requiredEntitlement: 'PATIENT_MANAGEMENT',
      breadcrumbs: [
        { label: () => i18next.t('nav.patients'), to: '/patients' },
        { label: () => i18next.t('patient.profile') },
      ],
    },
  },
];
